<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>运营工作移交</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区 -->
    <el-card class="box-card">
      <div  slot="header" class="flexContainer">
        <span  class="cardHeader">运营工作移交</span>
        <el-button style="float:right;" type="primary" size="normal" @click="createClickHandler">新建xxx</el-button>
      </div>

      <!-- 搜索条 -->
      <div>
        <el-form :model="queryInfo" :inline="true" size="normal">
          <el-form-item label="关键词：">
            <el-input clearable v-model="queryInfo.query" placeholder="关键字" @clear="getList"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList">查询</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 表格区域 -->
      <el-table :data="list" border style="margin-top:0px">
        <el-table-column label="编号" type="index" width="60px"></el-table-column>
        <el-table-column label="角色名称" prop="name"></el-table-column>
        <el-table-column label="角色描述" prop="desc"></el-table-column>
        <el-table-column label="模块归属" prop="moduleCode"></el-table-column>
        <el-table-column label="菜单" prop="moduleCode"></el-table-column>
        <el-table-column label="权限" prop="moduleCode"></el-table-column>
        <el-table-column label="操作"  width="120px">
          <template slot-scope="scope">
            <el-button type="primary" plain size="default" @click="modifyClickHandler(scope.row)">修改</el-button>
            <el-button type="primary" plain size="default" @click="deleteClickHandler(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10,20,50]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

  </div>
</template>

<script>
export default {
  data () {
    return {
      list: [],
      queryInfo: {
        query: '',
        pagenum: 1,
        pagesize: 10
      },
      total: 0
    }
  },
  created () {
    // this.base = window.sessionStorage.getItem('base')
    this.getList()
  },
  methods: {
    // 获取列表
    async getList () {
      const { data: res } = await this.$http.get('web/builtInRole', { params: this.queryInfo })
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.list = res.data.list
    },

    // 监听pagesize改变的事件
    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.getList()
    },

    // 监听页码改变
    handleCurrentChange (newPage) {
      this.queryInfo.pagenum = newPage
      this.getList()
    },

    // 点击添加按钮
    async createClickHandler () {
      this.$router.push('/路由/add')
    },

    // 点击修改按钮
    async modifyClickHandler (row) {
      this.$router.push('/路由/modify')
    },

    // 点击删除按钮
    async deleteClickHandler (row) {
      const confirmResult = await this.$confirm(
        '确定要删除吗？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err)
      if (confirmResult === 'cancel') return this.$message.info('操作已经取消')

      const { data: res } = await this.$http.delete('xxxx/$row')

      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.$message.success(res.meta.msg)
      this.getList()
    }
  }
}
</script>

<style lang="less" scoped>

</style>
